<div class="powered-by-vana" [class.powered-by-vana--compact]="compact()">
  <span class="powered-by-vana__label">Powered by</span>
  <a
    class="powered-by-vana__link"
    href="https://vanaintellikrafts.in"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      class="powered-by-vana__logo"
      src="assets/vana-logo.png"
      alt=""
      width="24"
      height="24"
    />
    <span class="powered-by-vana__name">Vana Intellikrafts Solutions Private Limited</span>
  </a>
</div>
